(function() {
  'use strict';

  angular.module('app.forms')
    .directive('fhFormRealtor', [function() {
      return {
        restrict: "E",
        scope: {},
        bindToController: true,
        controllerAs: 'vm',
        templateUrl: 'forms/fh-form-realtor',
        link: function() {},
        controller: [
          'FormService',
          'DeviceService',
          'AnalyticsService',
          function(
            FormService,
            DeviceService,
            AnalyticsService
          ) {

            var self = this,
              prefillMode = false,
              prefillData = FormService.prefillForm(prefillMode, 'realtorProgram');

            self.formData    = prefillData.formData;
            self.formResult  = prefillData.formResult;

            self.regions = [
                {id: 'Atlanta', name: 'Atlanta'},
                {id: 'Cincinnati', name: 'Cincinnati'},
                {id: 'Columbus', name: 'Columbus'},
                {id: 'Indianapolis', name: 'Indianapolis'},
                {id: 'Louisville', name: 'Louisville'}
              ];

            self.analyticsConfig = {
              googleAnalytics: {
                pageViewUrl: '/ajax-goals/for-realtors'
              }
            };

            self.checkFormValidation = function(form) {
              self.triedSubmit = true;

              if (! form.$valid) {
                return;
              }

              processGetInTouchForm();
            };

            function processGetInTouchForm() {
              self.formResult.showForm = false;
              self.formResult.showLoader = true;

              prepareFormData();

              FormService.submit('/forms/realtor-program', self.formData)
                .then(function(result) {
                  self.formResult = result;

                  AnalyticsService.logTrackingClick(self.analyticsConfig);

                });
            }

            function prepareFormData() {
              return;
            }

          }]
      };
    }]);
})();